export default __webpack_public_path__ + "static/media/pic4.0d847c52.jpg";